import { z } from 'zod';
export var SeatApplicationWorkflowStatus;
(function (SeatApplicationWorkflowStatus) {
    SeatApplicationWorkflowStatus["Draft"] = "draft";
    SeatApplicationWorkflowStatus["Published"] = "published";
    SeatApplicationWorkflowStatus["Archived"] = "archived";
})(SeatApplicationWorkflowStatus || (SeatApplicationWorkflowStatus = {}));
export var SeatApplicationWorkflowStepType;
(function (SeatApplicationWorkflowStepType) {
    SeatApplicationWorkflowStepType["MeetingBody"] = "meeting_body";
    SeatApplicationWorkflowStepType["MeetingBodyRole"] = "meeting_body_role";
    SeatApplicationWorkflowStepType["Position"] = "position";
    SeatApplicationWorkflowStepType["Users"] = "users";
})(SeatApplicationWorkflowStepType || (SeatApplicationWorkflowStepType = {}));
const stepSuperRefine = (data, ctx) => {
    if (data.type === SeatApplicationWorkflowStepType.Users) {
        // Transform data
        data.meetingBodyId = null;
        data.positionId = null;
        data.departmentId = null;
        data.meetingBodyRoleId = null;
        // Validate userIds
        if (!data.userIds || data.userIds.length === 0) {
            ctx.addIssue({
                code: 'custom',
                message: 'At least one contributor must be selected',
                path: ['userIds'],
            });
        }
    }
    else if (data.type === SeatApplicationWorkflowStepType.MeetingBody) {
        // Transform data
        data.userIds = [];
        data.positionId = null;
        data.departmentId = null;
        data.meetingBodyRoleId = null;
        // Validate meetingBodyId
        if (data.meetingBodyId === null) {
            ctx.addIssue({
                code: 'custom',
                message: 'Meeting body must be selected',
                path: ['meetingBodyId'],
            });
        }
    }
    else if (data.type === SeatApplicationWorkflowStepType.Position) {
        // Transform data
        data.userIds = [];
        data.meetingBodyId = null;
        data.meetingBodyRoleId = null;
        // Validate positionId
        if (data.positionId === null || data.positionId === undefined) {
            ctx.addIssue({
                code: 'custom',
                message: 'Position must be selected',
                path: ['positionId'],
            });
        }
    }
    else if (data.type === SeatApplicationWorkflowStepType.MeetingBodyRole) {
        // Transform data
        data.userIds = [];
        data.meetingBodyId = null;
        data.positionId = null;
        data.departmentId = null;
        // Validate meetingBodyRoleId
        if (data.meetingBodyRoleId === null || data.meetingBodyRoleId === undefined) {
            ctx.addIssue({
                code: 'custom',
                message: 'Meeting body role must be selected',
                path: ['meetingBodyRoleId'],
            });
        }
    }
};
// Workflow step validation schemas
const seatApplicationWorkflowStepBaseSchema = z.object({
    name: z.string('Name is required').min(1, 'Name is required'),
    description: z.string().nullish(),
    type: z.enum(SeatApplicationWorkflowStepType, 'Invalid step type'),
    userIds: z.array(z.number(), 'User IDs must be an array of numbers').optional(),
    meetingBodyId: z.number('Meeting body ID must be a number').nullish(),
    positionId: z.number('Position ID must be a number').nullish(),
    departmentId: z.number('Department ID must be a number').nullish(),
    meetingBodyRoleId: z.number('Meeting body role ID must be a number').nullish(),
    insertAfterId: z.number().optional(), // ID of step to insert after, or undefined for end
});
export const seatApplicationWorkflowStepCreateSchema = seatApplicationWorkflowStepBaseSchema.superRefine(stepSuperRefine);
export const seatApplicationWorkflowStepUpdateSchema = seatApplicationWorkflowStepBaseSchema
    .partial()
    .superRefine(stepSuperRefine);
// Workflow validation schema
export const seatApplicationWorkflowCreateSchema = z.object({
    name: z.string('Name is required').min(1, 'Name is required'),
    description: z.string().nullish(),
});
export const seatApplicationWorkflowUpdateSchema = seatApplicationWorkflowCreateSchema.partial();
// Meeting body assignment schema
export const seatApplicationWorkflowMeetingBodyAssignmentSchema = z.object({
    meetingBodyIds: z.array(z.number(), 'Meeting body IDs are required'),
});
